// extracted by mini-css-extract-plugin
module.exports = {"modal":"ActivatePatient_modal__30oDU","divider":"ActivatePatient_divider__1Zzhr","title":"ActivatePatient_title__1ldJQ","btnWrapper":"ActivatePatient_btnWrapper__1q_G2"};